import type { VfConfig } from '#types/config/components/vf'

export default {
  showErrorIcon: false
} satisfies VfConfig['textarea']
